<template>
  <div>
    <a
      data-toggle="collapse"
      :href="'#collapse_' + group.id"
      class="flex-container collapsed w-100 flex-body mt-3 d-flex group-item"
      style="justify-content:space-between"
    >
      <div class="item text-center d-flex w-100 pl-2">
        <i class="fas fa-bars text-white mt-1"></i>
        <div class="item group-name text-white">{{ group.title }}</div>
      </div>
      <div class="item text-white text-right pr-3">
        <a href="javascript:void(0)" class="action-btn text-white"
          ><i class="fa fa-eye"></i
        ></a>
        <a
          href="javascript:void(0)"
          @click="deleteGroup(group.id)"
          class="action-btn text-white"
          ><i class="fa fa-trash"></i
        ></a>
        <a
          href="javascript:void(0)"
          @click="editGroup(group)"
          data-toggle="modal"
          class="action-btn text-white"
          ><i class="fas fa-pencil-alt"></i
        ></a>
      </div>
    </a>
    <!--        ITEMGROUP Modal-->
    <div
      class="modal fade"
      :id="'edititemGroup' + group.id"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <h5 class="text-uppercase">Create new itemtype</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group d-flex">
                      <div class="circle">
                        <img
                          :src="
                            group.image
                              ? group.image
                              : 'https://www.pinclipart.com/picdir/big/322-3225911_gallery-icon-uniao-da-direita-clipart.png'
                          "
                        />
                      </div>
                      <div class="ml-4 mt-4">
                        <input
                          @change="readImage()"
                          type="file"
                          class="d-none"
                          id="itemtypefile"
                        />
                        <button class="btn btn-dark btn-sm">
                          <label class="p-0 m-0" for="itemtypefile"
                            >Upload</label
                          >
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Name</label>
                      <input
                        v-model="group.title"
                        type="text"
                        class="form-control"
                        id="name"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Description::</label>
                      <editor
                        :id="'textarea' + group.id"
                        v-model="group.description"
                        :init="{
                          height: 200,
                          menubar: false,
                          language: 'nl',
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                            alignleft aligncenter alignright alignjustify | \
                                                            bullist numlist outdent indent | removeformat | help',
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-12 pl-md-2 pr-md-5">
                <div class="row">
                  <div class="col-md-12 col-12 mb-3 p-0">
                    Select itemgroups:
                  </div>
                  <div class="col-md-12 col-12">
                    <select2itemgroups></select2itemgroups>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 col-12 mb-3 p-0">
                    Related member if proceeds:
                    <members></members>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button @click="updateItemgroup()" class="btn-dark btn-sm btn">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import select2itemgroups from "../../../layout/components/selectitemgroups";
import members from "../../../layout/components/selectmembers";
export default {
  name: "itemgroup",
  props: ["group"],
  components: {
    select2itemgroups,
    members,
  },
  data() {
    return {
      committees: [],
    };
  },
  computed: {
    ...mapState({
      itemgroup_parent_id: (state) => state.itemgroup_parent_id,
      selectedMembers: (state) => state.selectedMembers,
      selectedItemgroups: (state) => state.selectedItemgroups,
    }),
  },
  methods: {
    editGroup(grp) {
      var modalID = "#edititemGroup" + grp.id;
      window.$(modalID).modal("show");

      var selectedMembers = grp.members.map((item) => {
        return { id: item.id, text: item.display_name };
      });

      var selectedItemgroups = grp.itemgroups.map((item) => {
        return { id: item.id, text: item.title };
      });
      this.$store.state.selectedMembers = selectedMembers;
      this.$store.state.selectedItemGroups = selectedItemgroups;
    },
    updateItemgroup() {
      var selected_members = this.selectedMembers.map((d) => d.id);
      this.group.selected_members = JSON.stringify(selected_members);

      var selected_itemgroups = this.selectedItemgroups.map((d) => d.id);
      this.group.selected_itemgroups = JSON.stringify(selected_itemgroups);

      this.$store
        .dispatch("put", {
          endpoint: "api/v1/itemtypes/" + this.group.id,
          details: this.group,
        })
        .then((data) => {
          // window.location.reload();
          console.log(data);
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    deleteGroup(id) {
      if (!window.confirm("Are you sure you want to delete this item?")) {
        return false;
      }
      console.log(id);
      this.$store
        .dispatch("delete", "api/v1/itemtypes/" + id)
        .then((d) => {
          console.log(d);
          window.location.reload();
        })
        .catch((e) => console.log(e));
    },
    setParentId(id) {
      this.$store.state.itemgroup_parent_id = id;
    },
  },
};
</script>
<style scoped>
.field {
  background: #4192D9;
  border-radius: 10px;
  color: white;
  margin-top: 5px !important;
}
.circle img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid lightgray;
}
.card-body {
  background: transparent;
  border: none;
  padding: 0px 0px 0px 30px;
}
.card-body .group-item {
  margin-top: 5px !important;
}
.group-item .fa-chevron-right {
  transform: rotate(90deg);
}
.group-item.collapsed .fa-chevron-right {
  transform: rotate(0deg);
}
.group-item {
  text-decoration: none;
}
.action-btn {
  font-size: 13px;
  margin-right: 5px;
}
.group-name {
  font-size: 12px;
  text-align: left;
  margin-left: 10px !important;
}
.search-box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #292929;
  border-radius: 4px;
  height: 40px;
  width: 20rem;
}

.search-btn {
  background: transparent;
  border: unset;
  margin-left: -30px;

  -webkit-appearance: none;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 18px !important;
}

.custom-row {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  opacity: 1;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;

  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 1px 5px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  padding: 0px 0;
  width: auto;
}
</style>
